export default "__VITE_ASSET__vHLzkvnr__"